/* eslint-disable */
import { observable, action } from 'mobx'
import axios from 'axios'
import qs from 'qs'

import Auth from './Auth'

import config from '../config'

class Blog {
  @observable posts = []
  @observable
  pagination = {
    page: 1,
    max: 1,
    limit: 10
  }

  @action
  setPagination = data => {
    this.pagination = {
      ...this.pagination,
      ...(data.page ? { page: data.page } : {}),
      ...(data.limit ? { limit: data.limit } : {})
    }
  }

  @action
  postPost = data => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/blog/`,
      data: {
        title: data.title,
        content: data.content
      },
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.posts.replace([...this.posts, res.data.data])

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  getPost = id => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/blog/${id}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        const _postIndex = this.posts.slice().findIndex(p => p.id === id)

        this.posts.replace([
          ...(_postIndex > -1
            ? [
                ...this.all.slice().slice(0, _postIndex),
                { ...res.data.data },
                ...this.all.slice().slice(_postIndex + 1)
              ]
            : [...this.all.slice(), { ...res.data.data }])
        ])

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  searchPost = seo => {
    const _query = qs.stringify({
      type: 'blogpost',
      q: seo,
      limit: 1,
      page: 1
    })

    return axios({
      method: 'get',
      url: `${config.api_uri}/search/?${_query}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        const _post = res.data.hits.hits[0]._source
        const _postIndex = this.posts.slice().findIndex(p => p.seo === seo)

        this.posts.replace([
          ...(_postIndex > -1
            ? [
                ...this.posts.slice().slice(0, _postIndex),
                { ..._post },
                ...this.posts.slice().slice(_postIndex + 1)
              ]
            : [...this.posts.slice(), { ..._post }])
        ])

        return _post
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  patchPost = (id, field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/blog/${id}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: `replace`,
        path: `/${field}`,
        value
      }
    })
      .then(res => {
        const _postIndex = this.posts.slice().findIndex(p => p.id === id)

        this.posts.replace([
          ...(_postIndex > -1
            ? [
                ...this.posts.slice().slice(0, _postIndex),
                {
                  ...this.posts.slice()[_postIndex],
                  [field]: value
                },
                ...this.posts.slice().slice(_postIndex + 1)
              ]
            : [
                ...this.posts.slice(),
                {
                  ...this.posts.slice()[_postIndex],
                  [field]: value
                }
              ])
        ])

        return {
          ...this.posts.slice()[_postIndex],
          [field]: value
        }
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  searchPosts = data => {
    const _query = qs.stringify({
      type: 'blogpost',
      ...(data.q ? { q: data.q } : {}),
      ...(data.page ? { page: data.page } : { ...this.pagination }),
      sortKey: 'createdAt',
      sortType: 'desc'
    })

    return axios({
      method: 'get',
      url: `${config.api_uri}/search/?${_query}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.pagination = {
          ...this.pagination,
          max: Math.max(
            Math.round(res.data.hits.total.value / this.pagination.limit),
            this.pagination.page
          )
        }

        this.posts.replace([
          ...res.data.hits.hits.reduce((arr, p) => [...arr, p._source], [])
        ])

        return this.posts
      })
      .catch(e => {
        console.warn(e)
      })
  }
}

export default new Blog()



// WEBPACK FOOTER //
// ./src/stores/Blog.js